import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Precontrattuale = () => {
  return (
    <main data-testid="precontrattuale-page" className="bg-ivory text-navy min-h-screen pt-24">
      <div className="container-editorial py-20 md:py-28 max-w-3xl">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-muteText hover:text-navy mb-12"
        >
          <ArrowLeft size={14} /> Torna alla home
        </Link>

        <p className="overline mb-6">Documento informativo</p>
        <h1 className="display-2 mb-10">Informativa Precontrattuale</h1>

        <div className="space-y-6 text-muteText leading-relaxed">
          <p>
            Ai sensi dell'art. 165 del Regolamento adottato con Delibera Consob
            n. 20307/2018 (il "Regolamento Intermediari") si forniscono di
            seguito le informazioni su Faustini Manuel (d'ora innanzi il
            "CONSULENTE") e sui servizi da esso svolti.
          </p>
          <p>
            Le informazioni contenute nel presente Documento devono essere
            fornite al cliente o potenziale cliente prima che questi sia
            vincolato da un accordo per la prestazione del servizio di
            consulenza in materia di investimenti o comunque prima della
            prestazione di tale servizio.
          </p>
          <p>
            Il destinatario del presente documento è invitato a leggere quanto
            segue prima di prendere qualsiasi decisione circa la stipulazione
            di un contratto di consulenza in materia di investimenti. Il
            CONSULENTE è a disposizione per fornire ulteriori informazioni
            circa la natura e le caratteristiche del servizio di consulenza in
            materia di investimenti.
          </p>
        </div>

        <Section title="1. Informazioni sul Consulente">
          <ul className="space-y-2">
            <li><strong className="text-navy">Nome e Cognome:</strong> Faustini Manuel</li>
            <li><strong className="text-navy">Domicilio:</strong> Via Giacomo Quarenghi 6, 24050, Calcinate (BG)</li>
            <li><strong className="text-navy">E-mail:</strong> faustinimanuelcfa@gmail.com</li>
            <li><strong className="text-navy">PEC:</strong> faustinimanuel@pec.it</li>
            <li><strong className="text-navy">Telefono:</strong> +39 347 648 3171</li>
            <li>Iscritto con delibera n. 2046 del 25/10/2022 nella sezione CFA dell'Albo unico dei consulenti finanziari.</li>
          </ul>
        </Section>

        <Section title="2. Lingua utilizzata">
          <p>
            Il Cliente potrà comunicare con il CONSULENTE e ricevere da esso
            documenti e informazioni in lingua italiana.
          </p>
        </Section>

        <Section title="3. Metodi di comunicazione utilizzati">
          <p>
            L'invio di lettere, note informative, rendiconti, le eventuali
            notifiche e qualunque altra dichiarazione o comunicazione scritta,
            comprese le modifiche delle informazioni contenute nel presente
            Documento, ove non diversamente previsto dalla legge o dal
            contratto, saranno effettuate al Cliente con pieno effetto
            all'indirizzo indicato all'atto della sottoscrizione del contratto
            o comunicato successivamente per iscritto.
          </p>
          <p>
            Il Cliente può scegliere, al momento della sottoscrizione del
            contratto relativo al servizio di consulenza o con successiva
            comunicazione per iscritto, di ricevere le informazioni tramite
            supporto duraturo non cartaceo e, in particolare, tramite e-mail.
            A tal fine, il Cliente indicherà un indirizzo e-mail valido ed
            accessibile unicamente a lui e si impegna a mantenerlo attivo (o
            comunicare per iscritto un diverso indirizzo e-mail valido) sino a
            14 mesi dopo lo scioglimento del contratto.
          </p>
          <p>
            Le comunicazioni e/o eventuali notifiche al CONSULENTE dovranno
            essere effettuate dal Cliente al domicilio del CONSULENTE ovvero a
            mezzo posta elettronica certificata agli indirizzi sopra indicati.
          </p>
          <p>
            L'invio delle raccomandazioni da parte del CONSULENTE e la
            conferma dell'esecuzione delle operazioni da parte del Cliente
            potranno essere effettuate mediante le seguenti modalità:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>posta (lettera raccomandata A/R);</li>
            <li>consegna a mano;</li>
            <li>piattaforme di comunicazione via internet con utenza appositamente indicata dal Consulente;</li>
            <li>posta elettronica ordinaria, all'indirizzo indicato nel contratto;</li>
            <li>posta elettronica certificata (PEC), all'indirizzo indicato nel contratto;</li>
            <li>fax.</li>
          </ul>
        </Section>

        <Section title="4. Iscrizione nell'Albo previsto dall'art. 18-bis del D.Lgs. 24.02.1998 n. 58">
          <p>
            Si dichiara che il CONSULENTE è iscritto nella sezione dell'albo
            di cui all'art. 18-bis del Decreto Legislativo 24/02/1998 (TUF)
            tenuto dall'Organismo di Vigilanza previsto dall'art. 31, comma 4
            del suddetto Decreto, con delibera del 25/10/2022 n. 2046.
          </p>
          <p>
            Il nome e l'indirizzo di contatto dell'Organismo sono disponibili
            su:{" "}
            <a
              href="https://www.organismocf.it/portal/web/portale-ocf/contatti"
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline text-navy"
            >
              organismocf.it/contatti
            </a>
            .
          </p>
        </Section>

        <Section title="5. Relazioni sull'esecuzione del servizio di consulenza">
          <p>
            Il CONSULENTE invia al Cliente i seguenti rendiconti relativi alla
            prestazione del servizio di consulenza:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              entro 30 giorni dalla fine di ogni trimestre/semestre/anno
              solare un rendiconto contenente la composizione e l'andamento
              del Portafoglio;
            </li>
            <li>
              entro 60 giorni dalla fine dell'anno solare, un rendiconto
              contenente:
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>una dichiarazione aggiornata che indichi i motivi secondo cui il Portafoglio corrisponde alle preferenze, agli obiettivi e alle altre caratteristiche del Cliente;</li>
                <li>le raccomandazioni fornite nel periodo di riferimento;</li>
                <li>in forma aggregata, i costi e gli oneri del Servizio prestato e dei Prodotti Finanziari e servizi oggetto di raccomandazione.</li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title="6. Politica sui conflitti di interesse">
          <p>
            Ai sensi dell'art. 177 del Regolamento Intermediari il CONSULENTE
            ha adottato una Politica sui conflitti di interesse finalizzata a:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>individuare, in riferimento al servizio di consulenza in materia di investimenti, le circostanze che generano o potrebbero generare un conflitto di interesse che possa ledere gli interessi di uno o più clienti, comprese le sue preferenze di sostenibilità;</li>
            <li>definire le procedure da seguire e le misure da adottare per prevenire o gestire tali conflitti.</li>
          </ul>
          <p>
            Le procedure e le misure adottate sono volte a identificare e
            prevenire i conflitti di interesse che potrebbero insorgere tra il
            CONSULENTE e il Cliente o tra il Cliente e altri clienti del
            CONSULENTE al momento della prestazione del Servizio oggetto del
            presente Contratto, al fine di evitare che tali conflitti incidano
            negativamente sul Cliente.
          </p>
          <p>
            Il CONSULENTE, ove le misure adottate non siano sufficienti a
            evitare con ragionevole certezza il rischio di danneggiare gli
            interessi del Cliente, informerà chiaramente su supporto durevole
            il Cliente della natura generale e/o delle fonti dei potenziali
            conflitti di interesse derivanti dalle raccomandazioni fornite,
            nonché delle misure adottate per mitigare i rischi connessi,
            affinché il Cliente possa assumere una decisione di investimento
            informata.
          </p>
          <p>
            Il Cliente può richiedere al CONSULENTE ulteriori dettagli
            analitici sulla politica di gestione dei conflitti di interessi
            ai recapiti precedentemente indicati.
          </p>
        </Section>

        <Section title="7. Attività prestata e modalità di svolgimento">
          <p>
            Il CONSULENTE svolge il servizio di consulenza in materia di
            investimenti di cui all'art. 1, comma 5, lettera f) del TUF,
            consistente nella "prestazione di raccomandazioni personalizzate
            ad un cliente, dietro sua richiesta o per iniziativa del
            prestatore del servizio, riguardo a uno o più operazioni relative
            a strumenti finanziari".
          </p>
          <p>In particolare, il servizio prestato dal CONSULENTE ha per oggetto:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>l'analisi dell'allocazione del Portafoglio complessivo del cliente e della valutazione dell'efficienza dei prodotti detenuti;</li>
            <li>l'eventuale riformulazione dell'asset allocation del portafoglio e degli strumenti e dei prodotti finanziari detenuti sulla base delle informazioni fornite dal cliente;</li>
            <li>la valutazione periodica, con frequenza annuale, dell'adeguatezza del Portafoglio.</li>
          </ul>
          <p>
            Le raccomandazioni personalizzate fornite al Cliente in esecuzione
            del servizio possono avere ad oggetto un'ampia gamma di strumenti
            finanziari riconducibili alle seguenti categorie riportate
            nell'allegato 1, sezione C, del TUF:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>a) Valori mobiliari;</li>
            <li>b) Quote e azioni di O.I.C.R.</li>
          </ul>
          <p>
            Le raccomandazioni personalizzate possono avere ad oggetto anche
            prodotti finanziari diversi dagli strumenti finanziari, quali i
            prodotti finanziari emessi da imprese di assicurazioni e i
            prodotti finanziari emessi da banche, nonché il servizio di
            gestione di portafogli e il servizio di ricezione e trasmissione
            ordini.
          </p>
          <p>
            Il CONSULENTE si riserva la possibilità di svolgere i servizi
            accessori di cui al n. 3 e n. 5 dell'Allegato 1, sezione B, del
            TUF. Non è prevista la prestazione di raccomandazioni non
            personalizzate.
          </p>
          <p>
            In merito ad eventuali ulteriori attività professionali svolte dal
            CONSULENTE, si precisa che non sono oggetto della vigilanza della
            Consob né dell'Organismo. La predetta attività di consulenza è
            rivolta sia ai clienti al dettaglio sia a clienti professionali.
          </p>
          <p>
            Nello svolgimento dell'attività il CONSULENTE non ha l'obbligo di
            aggiornare le raccomandazioni prestate al Cliente e di comunicare
            al Cliente le perdite subite sugli strumenti oggetto di
            raccomandazione. Il Cliente è libero di non dar corso alle
            operazioni di investimento/disinvestimento consigliate in
            esecuzione del presente contratto.
          </p>
          <p>
            Il Servizio può essere erogato dal CONSULENTE anche in luogo
            diverso dal suo domicilio. Il CONSULENTE non è autorizzato ad
            eseguire le operazioni raccomandate al cliente, il quale potrà
            effettuarle per il tramite degli intermediari abilitati (banche,
            SIM, SGR) nell'ambito dei servizi di investimento e delle
            attività da queste prestate.
          </p>
          <p>
            Quale remunerazione per lo svolgimento del servizio di consulenza
            il Cliente è tenuto a pagare al CONSULENTE una parcella
            commisurata al contenuto ed al valore del servizio. In mancanza di
            una modalità univoca di quantificazione del compenso, essa può
            variare in funzione della complessità e dalla dimensione del
            patrimonio sotto consulenza, degli obiettivi e dal profilo di
            rischio del cliente ed in linea generale dal tempo che il
            CONSULENTE dedicherà all'analisi e allo studio sulla fattispecie
            concreta. Il CONSULENTE si impegna a sottoporre al potenziale
            Cliente, dopo che questi gli abbia fornito le necessarie
            informazioni sopra sintetizzate, in tempo utile prima che questi
            sia vincolato da un accordo, un preventivo di parcella
            personalizzato. Modalità e tempi di pagamento saranno indicati nel
            suddetto preventivo.
          </p>
          <p>
            La parcella pagata dal Cliente costituisce, per previsione di
            legge e per vincolo contrattuale, l'unica forma di remunerazione
            del CONSULENTE per i servizi prestati al Cliente; al CONSULENTE è
            vietato percepire compensi (incentivi) da parte di soggetti terzi.
          </p>
          <p>
            Il CONSULENTE è tenuto, per deontologia professionale, ad essere
            indipendente rispetto agli emittenti dei prodotti finanziari
            raccomandati, nonché rispetto agli intermediari abilitati allo
            svolgimento dei servizi di investimento nell'ambito dei quali il
            Cliente esegue le raccomandazioni.
          </p>
          <p>
            Nella prestazione del servizio di consulenza il CONSULENTE non
            può detenere fondi o titoli appartenenti ai clienti.
          </p>
          <p>
            Il Cliente ed il CONSULENTE possono eventualmente concordare che
            il CONSULENTE abbia una delega a visionare gli investimenti del
            Cliente presso le banche o gli intermediari finanziari o le
            società di gestione del risparmio che il Cliente utilizza, senza
            alcuna autorizzazione ad operare. Possono eventualmente concordare
            altresì che le dette imprese di investimento inviino direttamente
            al CONSULENTE le informative sulle operazioni eseguite dal
            Cliente.
          </p>
          <p>
            Per maggiori informazioni sui contenuti del servizio di consulenza
            e sugli obblighi del CONSULENTE e del cliente si rinvia al
            contratto di consulenza in materia di investimenti che deve
            essere sottoscritto preventivamente allo svolgimento del servizio.
          </p>
        </Section>

        <Section title="8. Valutazione periodica dell'adeguatezza">
          <p>
            Nello svolgimento del servizio di consulenza in materia di
            investimenti il CONSULENTE fornisce al Cliente raccomandazioni in
            relazione ad operazioni di investimento o disinvestimento che, se
            eseguite, consentano l'adeguatezza del Portafoglio rispetto al
            profilo del Cliente ricostruito sulla base delle informazioni
            fornite mediante compilazione del Questionario sottopostogli prima
            della conclusione del presente contratto o in occasione di
            eventuali successivi aggiornamenti.
          </p>
          <p>In particolare, il CONSULENTE verifica che l'operazione raccomandata:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>corrisponda agli obiettivi di investimento del Cliente, inclusa la sua tolleranza al rischio;</li>
            <li>sia di natura tale che il Cliente sia finanziariamente in grado di sopportare i rischi connessi all'investimento compatibilmente con i suoi obiettivi di investimento;</li>
            <li>sia di natura tale per cui il Cliente possieda le necessarie conoscenze per comprendere i rischi connessi alla gestione del suo portafoglio.</li>
          </ul>
          <p>
            Il CONSULENTE effettua una valutazione periodica dell'adeguatezza
            del Portafoglio con frequenza ANNUALE.
          </p>
          <p>
            La valutazione di adeguatezza è svolta per consentire al
            consulente di agire secondo il migliore interesse del cliente. È
            pertanto indispensabile che il Cliente, mediante la compilazione
            del Questionario sottopostogli dal CONSULENTE, fornisca
            informazioni corrette e aggiornate concernenti:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>le sue conoscenze ed esperienze in materia di investimenti riguardo al tipo specifico di prodotto o servizio;</li>
            <li>la sua situazione finanziaria, compresa la sua capacità di sostenere le perdite;</li>
            <li>i suoi obiettivi di investimento, compresa la sua tolleranza al rischio;</li>
            <li>le sue preferenze di sostenibilità.</li>
          </ul>
          <p>
            Il Cliente è tenuto a comunicare al CONSULENTE eventuali
            aggiornamenti delle informazioni. Le suddette informazioni
            consentono al CONSULENTE di comprendere le caratteristiche
            essenziali del Cliente e di raccomandargli prodotti finanziari e
            servizi di investimento che siano adeguati con particolare
            riferimento alla sua tolleranza al rischio, alla sua capacità di
            sostenere perdite e alle sue preferenze di sostenibilità; nel caso
            in cui il Cliente non fornisca le informazioni previste nel
            Questionario, il servizio di consulenza non potrà essere prestato.
          </p>
          <p>
            Il Cliente deve rendersi consapevole che risposte errate o non
            veritiere possono compromettere l'attendibilità della valutazione
            di adeguatezza e diminuire il suo livello di tutela. Il
            CONSULENTE è tenuto ad astenersi dal formulare raccomandazioni se
            nessuno dei prodotti finanziari e dei servizi di investimento è
            adeguato per il Cliente.
          </p>
        </Section>

        <Section title="9. Integrazione dei fattori di sostenibilità">
          <p>
            Ai sensi dell'Art. 165 comma 1 lett. h-bis del Regolamento
            Intermediari, nel processo di selezione degli strumenti finanziari
            oggetto del servizio di consulenza in materia di investimenti, il
            CONSULENTE integra una valutazione in merito ai fattori di
            sostenibilità ambientale, sociale e di governance, al fine di
            garantire che i vari prodotti e strumenti possano essere
            raccomandati solamente a clienti che esprimono preferenze in tema
            di sostenibilità compatibili con le caratteristiche degli stessi
            strumenti.
          </p>
          <p>
            Dato che la consulenza svolta dal CONSULENTE riguarda il
            portafoglio finanziario nel suo complesso, la valutazione dei
            fattori di sostenibilità viene svolta a livello di portafoglio.
            Ciò significa che, nel suo complesso, il portafoglio dovrà essere
            allineato alle preferenze di sostenibilità del cliente, anche se
            è possibile che, per ragioni di gestione del rischio o di
            raggiungimento degli obiettivi del cliente, alcuni singoli
            strumenti utilizzati non siano singolarmente allineati alle
            preferenze del cliente.
          </p>
          <p>
            La valutazione delle caratteristiche di sostenibilità ambientale,
            sociale e di governance viene svolta, a seconda della tipologia
            di strumento/prodotto, secondo le informazioni dichiarate
            dall'emittente ai sensi delle regolamentazioni vigenti oppure
            utilizzando modelli di valutazione esterni (rating) e/o analisi
            svolte internamente.
          </p>
        </Section>

        <Section title="10. Altre attività professionali svolte da Faustini Manuel">
          <p>
            Faustini Manuel presta le seguenti attività ulteriori rispetto al
            servizio di consulenza in materia di investimenti:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Consulenza per la valutazione e la copertura delle esigenze di integrazione pensionistica;</li>
            <li>Consulenza per l'individuazione e quantificazione dei rischi del nucleo familiare;</li>
            <li>Consulenza per la pianificazione finanziaria personale e familiare;</li>
            <li>Consulenza per la pianificazione successoria familiare.</li>
          </ul>
          <p>
            Le suddette attività, pur essendo personalizzate, non hanno per
            oggetto specifici strumenti finanziari o prodotti finanziari. Lo
            svolgimento delle attività summenzionate è regolato da uno
            specifico contratto, distinto da quello relativo al servizio di
            consulenza in materia di investimenti, che prevede il pagamento
            di un compenso fisso o variabile di volta in volta concordato con
            il cliente, commisurato al contenuto ed al valore dell'attività
            prestata. Solo le attività sopra indicate, non rientranti tra i
            servizi accessori, sono sottratte alla vigilanza dell'Organismo.
          </p>
        </Section>

        <Section title="11. Strategie di investimento proposte">
          <p>
            Nello svolgimento del servizio di consulenza il CONSULENTE non è
            orientato su determinate categorie o una gamma specifica di
            strumenti finanziari.
          </p>
          <p>
            Il CONSULENTE non propone strategie di investimento standardizzate
            ma valuta per ogni Cliente la strategia più adeguata, tenuto
            conto degli obiettivi di investimento del Cliente, della sua
            tolleranza al rischio e della sua situazione finanziaria,
            compresa la sua capacità di sostenibilità delle perdite.
          </p>
        </Section>

        <p className="text-xs tracking-[0.22em] uppercase text-muteText mt-16">
          Ultimo aggiornamento: dicembre 2025
        </p>
      </div>
    </main>
  );
};

const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-serif text-2xl md:text-3xl text-navy mb-4">{title}</h2>
    <div className="space-y-4 text-muteText leading-relaxed">{children}</div>
  </section>
);

export default Precontrattuale;
